import type { ControlWithAnswer } from '@/modules/assessment/composables';
import type { AnswerConfirmation } from '@@/packages/shared/types/models/reassessment';

export const isApplicableControl = (controlWithAnswer: ControlWithAnswer) =>
  !controlWithAnswer.answer?.notApplicable;

export const isControlConfirmed = (
  controlWithAnswer: ControlWithAnswer,
  answerConfirmations: AnswerConfirmation[],
) => {
  const { answer } = controlWithAnswer;

  return !!(
    !isApplicableControl(controlWithAnswer) ||
    (answer &&
      answerConfirmations.find(
        (answerConfirmation) =>
          answerConfirmation.answerID === answer.answerID && answerConfirmation.confirmed,
      ))
  );
};

export function getConfirmedControlsWithAnswers(
  controlsWithAnswers: ControlWithAnswer[],
  answerConfirmations: AnswerConfirmation[],
) {
  const confirmedAnswers = controlsWithAnswers.filter((controlWithAnswer) =>
    isControlConfirmed(controlWithAnswer, answerConfirmations),
  );

  return confirmedAnswers;
}
